import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/storage"; // for storage
import "firebase/firestore"; // for cloud firestore

const firebaseConfig = {
  apiKey: "AIzaSyDn6Goric0imqwjpIgJPEDrgE1OyYtd254",
  authDomain: "jainsamaj-6c7cc.firebaseapp.com",
  projectId: "jainsamaj-6c7cc",
  storageBucket: "jainsamaj-6c7cc.appspot.com",
  messagingSenderId: "143691520619",
  appId: "1:143691520619:web:e8460b3e08a5ee07bd6f2e",
  measurementId: "G-ZC6RHP0X95",
};

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();
export { auth, db, storage };
